import { Link } from "react-router-dom";
import { Search } from "lucide-react";

export const SeoPagesTab = () => (
  <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm flex flex-wrap items-center gap-4" data-testid="seo-pages-tab">
    <Search className="w-6 h-6 text-blue-600" />
    <div className="flex-1 min-w-[200px]"><h2 className="text-lg font-bold text-slate-900">SEO command center</h2><p className="text-sm text-slate-500">Setup wizard, Google data, pages, keywords & competitors, technical audit, reports, demo funnel and client SEO dashboards — all in one place.</p></div>
    <Link to="/admin/seo" className="bg-blue-600 hover:bg-blue-500 text-white font-bold px-5 py-2.5 rounded-xl" data-testid="open-seo-dashboard">Open SEO command center</Link>
  </div>
);
